<template>
  <div id="home">
      <!-- 顶部导航条 -->
      <div id="home_nav">
        <top-nav></top-nav>     
      </div>
      <!-- 顶部标题区域 -->
      <div id="top_title">
          <div class="content">
              <h4>产品与服务 <i class="el-icon-arrow-right"></i> 授权与下载</h4>
              <input type="text" v-model="searchVal" @keyup.enter="searchContent()"/>
              <img src="/static/img/search.png" alt="搜索" @click="searchContent()">
          </div>
      </div>
      <!-- 主体部分 -->
      <div id="main">
          <!-- 左侧导航树 -->
          <div id="nav_tree">
              <nav-tree></nav-tree>
          </div>
          <!-- 右侧视图部分 -->
          <div id="right_view">
              <router-view ref="search"></router-view>
          </div>
      </div>
      <!-- 底部 -->
      <div class="footer">
          <div class="main">
              <div class="imgs" style="text-align: center;">
                  <img :src="QRcode" alt="二维码">
              </div>
              <div class="tips">
                  <p>
                      <a href="https://www.cmgos.com/web/about-us/contact/">联系我们</a>
                      <a href="https://www.cmgos.com/web/legal">法律声明</a>
                      <a href="http://beian.miit.gov.cn/">京ICP备：16058697号</a>
                      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022598">京公网安备11010802022598号</a>
                  </p>
                  <p>推荐使用IE 11.0以上、Chrome浏览器访问此网站</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav"
import NavTree from "@/components/NavTree"
import {navList} from "@/util/public"
export default {
    name: 'home',
    components: {
        TopNav,
        NavTree
    },
    beforeCreate: function() {
        if(this.$route.params.id === 'search') {
            this.$router.push({name: 'default'});
        };
    },
    data () {
        return {
            bottomNav: navList,
            searchVal: '',
            QRcode: '/static/img/QR_code.png'
        }
    },
    props: {},
    watch: {},
    methods: {
        searchContent: function() {
            /*去除前后空格*/ 
            let date = this.searchVal.replace(/(^\s*)|(\s*$)/g,'');
            let reg = /\/pcib/ig;
            if(reg.test(this.$route.path)) {
                this.$notify.info({
                    message: "该模块暂未提供该功能！",
                    offset: 30
                });
                this.searchVal = ''; 
                return false;
            }
            if (this.$route.params.id !== 'search') {
                this.$router.push({name: 'public', params: {id: 'search',date: date}});
            } else {
                this.$refs.search.homeSearch(date);
            }
            
            this.searchVal = '';            
        }
    },
    filters: {},
    computed: {},
    created () {},
    mounted () {},
    destroyed () {}
}
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue